export const prefixOptions = [
  {
    condition: /^Postnord/,
    getClass: () => 'bg-danger',
  },
  {
    condition: /^(Bedriftspakke|Bediftspakke)/,
    getClass: () => 'bg-danger',
  },
  {
    condition: /Henting.*Lyngdal/i,
    getClass: () => 'bg-success',
  },
  {
    condition: /Henting(?!.*Lyngdal)/,
    getClass: () => 'pickup-location',
  },
];
const defaultClass = 'bg-success';

// Mappings to get classes dynamically based on metadata and delivery location
export const metadataMapping = [
  { pattern: /^WORKSHOP$/, getClass: () => 'bg-info' },
  { pattern: /^regos_\d+$/, getClass: () => 'regos-tape' },
  {
    pattern: /^ordre_\d+$/,
    getClass: (delivery) => {
      if (!delivery) return defaultClass;

      const matchingLocation = prefixOptions.find(({ condition }) => condition.test(delivery));
      return matchingLocation ? matchingLocation.getClass() : defaultClass;
    },
  },
  /* === Catch anything that's not found in other matches === */
  { pattern: /.*/, getClass: () => defaultClass },
];

export const stripHtmlTags = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const getRowClass = (row) => {
  if (row.notes && !row.noteType) return 'bg-primary';
  if (row.notes && row.noteType === 1) return 'wrong-ean text-white';
  if (row.notes && row.noteType === 2) return 'unavailable-goods text-white';
  if (row.notes && row.noteType === 3) return 'goods-replaced-with text-dark';
  if (row.notes && row.noteType === 4) return 'bg-danger text-muted';

  return '';
};
